// src/pages/LandingPage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';

const LandingPage = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [stats, setStats]       = useState(null);
  const navigate = useNavigate();

  /* ── fetch stats publik (per bulan) ──────────── */
  useEffect(() => {
    const fetchStats = async () => {
      try {
        const r = await fetch('/api/stats/publik/');
        if (!r.ok) return;
        const d = await r.json();
        setStats(d);
      } catch { /* network err, tetap tampil 0 */ }
    };
    fetchStats();
  }, []);

  return (
    <div className="landing-wrapper">

      {/* ============================
          NAVBAR
          ============================ */}
      <nav className="navbar">
        <div className="navbar-logo">
          <img
            src="/logolemhannas.png"
            alt="Logo Lemhannas"
            className="logo-img"
          />
        </div>
        <button className="btn-login" onClick={() => navigate('/login')}>Login</button>
      </nav>

      {/* ============================
          HERO SECTION
          ============================ */}
      <section className="hero">
        <div className="hero-content">
          <span className="hero-badge">
            <span className="badge-dot"></span>
            SISTEM PENGADUAN RESMI
          </span>
          <h1 className="hero-title">
            Laporkan Keluhan Anda<br />dengan Mudah
          </h1>
          <p className="hero-subtitle">
            Sampaikan pengaduan secara transparan dan terstruktur.
          </p>
          <div className="hero-actions">
            <button className="btn-primary" onClick={() => navigate('/buat-pengaduan')}>+ Buat Pengaduan</button>
            <button className="btn-secondary" onClick={() => navigate('/cek-status')}>Cek Status</button>
          </div>
        </div>
        <div className="hero-mascot">
          <img
            src="/Picture1.png"
            alt="Maskot Lemhannas"
            className="mascot-img"
          />
        </div>
        <div className="hero-circle hero-circle-1"></div>
        <div className="hero-circle hero-circle-2"></div>
      </section>

      {/* ============================
          STATS SECTION
          ============================ */}
      <section className="stats-section">
        <div className="stats-grid">
          <div className="stat-card">
            <span className="stat-number">
              {stats?.bulan_ini ?? 0}
            </span>
            <span className="stat-label">Laporan bulan ini</span>
            <span className="stat-badge badge-active">● Aktif</span>
          </div>
          <div className="stat-card">
            <span className="stat-number stat-orange">
              {stats?.diproses ?? 0}
            </span>
            <span className="stat-label">Sedang diproses</span>
            <span className="stat-badge badge-process">● Proses</span>
          </div>
          <div className="stat-card">
            <span className="stat-number stat-green">
              {stats?.selesai ?? 0}
            </span>
            <span className="stat-label">Selesai</span>
            <span className="stat-badge badge-done">● Selesai</span>
          </div>
        </div>
      </section>

      {/* ============================
          CARA KERJA SECTION
          ============================ */}
      <section className="info-section">
        <div className="section-header">
          <span className="section-accent"></span>
          <h2 className="section-title">Cara kerja</h2>
        </div>
        <div className="steps-grid">
          <div className="step-card">
            <div className="step-number">1</div>
            <h3 className="step-title">Isi laporan</h3>
            <p className="step-desc">
              Lengkapi form dengan informasi jelas dan kronologis
            </p>
          </div>
          <div className="step-card">
            <div className="step-number">2</div>
            <h3 className="step-title">Dapat kode unik</h3>
            <p className="step-desc">
              Sistem memberi kode tracking untuk laporan Anda
            </p>
          </div>
          <div className="step-card">
            <div className="step-number">3</div>
            <h3 className="step-title">Pantau status</h3>
            <p className="step-desc">
              Cek perkembangan laporan kapan saja lewat kode
            </p>
          </div>
        </div>
      </section>

      {/* ============================
          KENAPA GUNAKAN SECTION
          ============================ */}
      <section className="info-section">
        <div className="section-header">
          <span className="section-accent"></span>
          <h2 className="section-title">Kenapa gunakan sistem ini?</h2>
        </div>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">⚡</div>
            <h3 className="feature-title">Cepat</h3>
            <p className="feature-desc">
              Laporan langsung masuk ke petugas terkait
            </p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">✏️</div>
            <h3 className="feature-title">Mudah</h3>
            <p className="feature-desc">
              Form sederhana, bisa diisi dari mana saja
            </p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🔍</div>
            <h3 className="feature-title">Transparan</h3>
            <p className="feature-desc">
              Status laporan dapat dipantau secara real-time
            </p>
          </div>
        </div>
      </section>

      {/* ============================
          FOOTER
          ============================ */}
      <footer className="footer">
        <div className="footer-inner">
          <div className="footer-left">
            <p className="footer-copy">
              Copyright © 2026 Designed<br />
              by{' '}
              <a href="#" className="footer-link">
                direktoratpuplemhannas.
              </a>
            </p>
            <p className="footer-rights">All rights reserved.</p>
            <div className="footer-socials">
              <a href="#" className="social-icon" aria-label="Instagram">
                <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a href="#" className="social-icon" aria-label="Twitter">
                <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                </svg>
              </a>
            </div>
          </div>
          <div className="footer-right">
            <h3 className="footer-brand">Sistem Pengaduan</h3>
            <p className="footer-desc">
              Direktorat Pelatihan Untuk Pelatih Kedeputian Pemantapan Nilai-Nilai Kebangsaan
              Lemhannas RI
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;